import { render } from "./videoDetail.vue?vue&type=template&id=4258df26&scoped=true"
import script from "./videoDetail.vue?vue&type=script&lang=js"
export * from "./videoDetail.vue?vue&type=script&lang=js"

import "./videoDetail.vue?vue&type=style&index=0&id=4258df26&scoped=true&lang=scss"
import "./videoDetail.vue?vue&type=style&index=1&id=4258df26&lang=css"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4258df26"]])

export default __exports__